<template>
  <v-container fluid class="employeeface-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/employeeface/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="employeefaces-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              :footer-props="footer"
              :headers="headers"
              :items="employeefaces"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Employee Face?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteemployeeface.employeefacename }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteemployeeface)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                {{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'] : ''}}
              </template>
              <template v-slot:item.employeefaceid="{ item }">
                {{ item.employeefaceid }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mock from "./mock"
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'EmployeeFaceList',
  data() {
    return {
      mock,
      config,
      snackbar: null,
      dialog: false,
      deleteemployeeface: {},
      headers: [
        { text: 'Name', value: 'employeeid' },
        { text: 'f1', value: 'f1' },
        { text: 'f128', value: 'f128' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      employeefaceid: ['admin', 'employeeface'],
      editedIndex: -1,
   
    }
  },

  computed: {
    ...mapState('EmployeeFace', ['employeefaces', 'isReceiving', 'isDeleting', 'idToDelete', 'employeefacesMessage', 'isUpdating']),
    ...mapState('Employee', ['employees']),
  },

  async created () {
    this.getEmployeeFacesRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
  },

  methods: {
    ...mapActions('EmployeeFace', [
      "getEmployeeFacesRequest",
      "deleteEmployeeFaceRequest",
      "updateEmployeeFaceRequest",
      "createEmployeeFaceRequest"
    ]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    deleteItem(item) {
      console.log(item);
      this.deleteEmployeeFaceRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteemployeeface = {
        _id: item._id,
        employeefacename: item.employeefacename,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
